<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="管理员ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入管理员id" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户名">
              <el-input v-model="queryParams.username" @change="search" @clear="search" placeholder="请输入用户名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="昵称">
              <el-input v-model="queryParams.nickname" @change="search" @clear="search" placeholder="请输入昵称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="角色组">
              <el-select v-model="queryParams.group" @change="search" @clear="search" placeholder="请选择角色组" clearable class="w100">
                <el-option v-for="dict in appidList" :key="dict.dictValue" :label="dict.name"
                           :value="dict.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" @change="search" @clear="search" placeholder="请选择状态" clearable class="w100">
                <el-option label="正常" value="1"></el-option>
                <el-option label="隐藏" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
        <!--                <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="用户名">
          <template slot-scope="scope">{{ scope.row.username }}</template>
        </el-table-column>
        <el-table-column prop="name" label="昵称">
          <template slot-scope="scope">{{ scope.row.nickname }}</template>
        </el-table-column>
        <el-table-column prop="name" label="角色组">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.group_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="最后登录">
          <template slot-scope="scope">{{ scope.row.logintime }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="jump(scope.row.id)">登录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList"/>
      <addmin v-if="dialogVisible" :dialogVisible="dialogVisible" @NoneDlog="NoneDlog" @AddOk="AddOk"
              :editID="editID"></addmin>
    </el-card>
  </div>
</template>

<script>
import {administratorsAPI} from '@/api/account/administrators';
import {processErrors} from "@/utils/errorHandler";
import {useLoginApi} from '@/api/login/index';
import addmin from "./component/addmin.vue"

export default {
  components: {
    addmin
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: "",
        username: "",
        queryParams: "",
        vip_username: "",
        platform_type: "",
        group: "",
        status: "",
      },
      appidList: [],
      page: {
        s:"/admin/group/option",
        pageNo: 1,
        pageSize: 999,
      },
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      EditObj: {
        username: "",
        nickname: "",
        password: "",
        email: "",
        mobile: "",
        status: "",
        id: ""
      },
      editID: "",
      // 总条数
      total: 0,
      loading:false,
    };
  },
  created() {
    this.getList()
    this.getroleList()
  },
  methods: {
    jump(id){
      let api = useLoginApi()
      api.getToken({id:id}).then(res => {
        if (res.code == 0) {
          let token = res.data.token;
          const urlParams = new URLSearchParams();
          urlParams.append('token', token)
          // 获取基础 URL
          const baseExportUrl = new URL(window.location.href).origin;
          // 拼接 URL 参数
          // window.location.href = baseExportUrl + '?' + urlParams.toString()
          let url = baseExportUrl + '?' + urlParams.toString()
          window.open(url);
        }else{
          processErrors(res);
        }
      })
    },
    getList() {
      this.loading = true
      let api = administratorsAPI()
      api.administratorsList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    getroleList() {
      let api = administratorsAPI()
      api.roleList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        id: "",
        username: "",
        queryParams: "",
        vip_username: "",
        platform_type: "",
        app_id: "",
        status: "",
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.dialogVisible = true
    },
    NoneDlog() {
      this.dialogVisible = false
    },
    AddOk() {
      this.dialogVisible = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id

      this.dialogVisible = true
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>